import apiRequest from './apiRequest';
import type { MotionEditorJobResponse } from './postSceneObjectMotionEdit';

export default async function getSceneObjectMotionEditJob(
  sceneID: string,
  referenceName: string,
  timelineIndex: number,
  jobID: string,
  apiKey: string,
  signal?: AbortSignal,
) {
  return apiRequest<MotionEditorJobResponse>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}/objects/${encodeURIComponent(referenceName)}/${timelineIndex}/motionEdits/${encodeURIComponent(jobID)}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
    signal,
  );
}
